(()=>{
const ARCH=['explorer','tastemaker','purist','classic'];
const COPY={
 explorer:{
  name:'The Explorer',
  tagline:'Apparently, you need your food to fight back.',
  copy:'Big flavour, novelty and contrast keep you interested. You’re more likely to order the wildcard, push the heat and enjoy cuisines that reward curiosity.'
 },
 tastemaker:{
  name:'The Tastemaker',
  tagline:'You notice everything — and still want dinner to surprise you.',
  copy:'Your palate is selective rather than cautious. You pick up detail quickly, but you still want complexity, precision and enough novelty to keep the meal interesting.'
 },
 purist:{
  name:'The Purist',
  tagline:'You don’t need more. You need it right.',
  copy:'You notice small differences in bitterness, texture and balance, and you’re happiest when ingredients are clean, deliberate and properly handled.'
 },
 classic:{
  name:'The Classic',
  tagline:'You know what works — and you’d rather it be brilliant than weird.',
  copy:'Food is pleasure, familiarity and good execution. You’re less interested in culinary theatre and more interested in dishes that deliver exactly what they promise.'
 }
};
function clamp(n){return Math.max(0,Math.min(100,Math.round(Number(n)||0)))}
function b64url(bytes){
 let s='';bytes.forEach(b=>s+=String.fromCharCode(b));
 return btoa(s).replace(/=+$/,'').replace(/\+/g,'-').replace(/\//g,'_')
}
function unb64url(token){
 let s=String(token||'').replace(/-/g,'+').replace(/_/g,'/');
 while(s.length%4)s+='=';
 const raw=atob(s),a=new Uint8Array(raw.length);
 for(let i=0;i<raw.length;i++)a[i]=raw.charCodeAt(i);
 return a
}
function enrich(obj){
 if(!obj)return null;
 const key=ARCH.includes(obj.key)?obj.key:'classic',text=COPY[key];
 return {
  v:2,key,
  name:text.name,tagline:text.tagline,copy:text.copy,
  adv:clamp(obj.adv),heat:clamp(obj.heat),intensity:clamp(obj.intensity),
  acid:clamp(obj.acid),texture:clamp(obj.texture),sweet:clamp(obj.sweet)
 }
}
function encode(obj){
 const p=enrich(obj),idx=ARCH.indexOf(p.key);
 const bytes=new Uint8Array(9);
 bytes[0]=2;bytes[1]=idx;
 bytes[2]=p.adv;bytes[3]=p.heat;bytes[4]=p.intensity;
 bytes[5]=p.acid;bytes[6]=p.texture;bytes[7]=p.sweet;
 let check=0;for(let i=0;i<8;i++)check^=bytes[i];bytes[8]=check;
 return b64url(bytes)
}
function decodeCompact(token){
 try{
  const a=unb64url(token);
  if(a.length!==9||a[0]!==2||a[1]>3)return null;
  let check=0;for(let i=0;i<8;i++)check^=a[i];
  if(check!==a[8])return null;
  return enrich({key:ARCH[a[1]],adv:a[2],heat:a[3],intensity:a[4],acid:a[5],texture:a[6],sweet:a[7]})
 }catch(e){return null}
}
function decodeLegacy(token){
 try{
  let s=String(token||'').replace(/-/g,'+').replace(/_/g,'/');
  while(s.length%4)s+='=';
  const obj=JSON.parse(decodeURIComponent(escape(atob(s))));
  return enrich(obj)
 }catch(e){return null}
}
function decode(token){
 if(!token)return null;
 return decodeCompact(token)||decodeLegacy(token)
}
window.TasteProfileCodecV132={encode,decode,enrich};
})();